import { UserCog, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

function fmt(v) {
  if (v === null || v === undefined || v === '') return '—';
  if (typeof v === 'number') return new Intl.NumberFormat('es-ES').format(v);
  return String(v);
}

const FIELD_LABEL = {
  department_id: 'Departamento',
  position:      'Puesto',
  gross_salary:  'Salario',
  status:        'Estado',
  email:         'Email',
  phone:         'Teléfono',
  contract_type: 'Contrato',
};

/**
 * UpdateEmployeePreview — preview for actualizar_empleado.
 * Shows the diff (campo: actual → nuevo) before confirmation.
 */
export default function UpdateEmployeePreview({ action, onApprove, onReject, status }) {
  const { preview } = action;

  if (status === 'approved') {
    return (
      <div className="flex items-center gap-2 p-2 bg-success/10 border border-success/30 rounded-lg text-xs text-success my-1">
        <UserCog className="w-3.5 h-3.5" />
        <span>Cambios aprobados — actualizando…</span>
      </div>
    );
  }
  if (status === 'rejected') {
    return (
      <div className="flex items-center gap-2 p-2 bg-muted border border-border rounded-lg text-xs text-muted-foreground my-1">
        <XCircle className="w-3.5 h-3.5" />
        <span>Actualización cancelada</span>
      </div>
    );
  }

  // Extract pairs *_actual/*_nuevo from preview
  const diffs = [];
  for (const k of Object.keys(preview ?? {})) {
    if (k.endsWith('_actual')) {
      const baseKey = k.slice(0, -'_actual'.length);
      diffs.push({
        campo:    baseKey,
        actual:   preview[k],
        nuevo:    preview[`${baseKey}_nuevo`],
      });
    }
  }

  return (
    <div className="rounded-xl border border-indigo-200 dark:border-indigo-800 bg-indigo-50/60 dark:bg-indigo-950/20 p-4 space-y-3 my-2 max-w-sm">
      <div>
        <Badge variant="outline" className="text-indigo-700 dark:text-indigo-300 border-indigo-300 dark:border-indigo-700 text-[10px] mb-1">
          Requiere aprobación
        </Badge>
        <p className="text-sm font-semibold text-foreground leading-tight">
          {preview?.empleado ?? '—'}
        </p>
      </div>

      <div className="text-xs space-y-1.5">
        {diffs.map((d, i) => (
          <div key={i} className="grid grid-cols-3 gap-2 items-baseline">
            <span className="text-muted-foreground truncate">{FIELD_LABEL[d.campo] ?? d.campo}</span>
            <span className="text-muted-foreground line-through truncate">{fmt(d.actual)}</span>
            <span className="font-semibold text-indigo-700 dark:text-indigo-300 truncate">{fmt(d.nuevo)}</span>
          </div>
        ))}
      </div>

      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={onReject} className="flex-1 h-7 text-xs">
          <XCircle className="w-3 h-3 mr-1" />Cancelar
        </Button>
        <Button size="sm" onClick={onApprove} className="flex-1 h-7 text-xs bg-indigo-600 hover:bg-indigo-700 text-white">
          <UserCog className="w-3 h-3 mr-1" />Actualizar
        </Button>
      </div>
    </div>
  );
}
